module.exports = __webpack_public_path__ + "static/media/logo_BSP.79d0449d.png";